import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { workWithUs } from "~/slices/WorkWithUs/fragment";

const PAGE_TYPE = "Work_with_us";

const QUERY_WORK_WITH_US = gql`
  query work_with_us($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}:work_with_us(uid: $uid, lang:$lang) {
      title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices {
        ...${PAGE_TYPE}
      }
    }
  }
  ${workWithUs(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_WORK_WITH_US };
